import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LocationDataParcelsSectionTitlePipe
} from '../../pipes/location-data-parcels-section-title.pipe';
import {
  LocationDataParcels2SectionTitlePipe
} from '../../pipes/location-data-parcels2-section-title.pipe';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../../components/parcels/parcels-preview/parcels-preview.component';
import { ApplicationAppEntityApplicationRead, ParcelAppEntityApplicationRead } from '../../../../../../../openapi';

@Component({
  selector: 'app-location-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    LocationDataParcelsSectionTitlePipe,
    LocationDataParcels2SectionTitlePipe
  ],
  templateUrl: './location-data-preview.component.html'
})
export class LocationDataPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;

  @Input()
  public propertyInfo: boolean = false;

  @Input()
  public propertyLegalTitle: boolean = false;

  public get parcels(): ParcelAppEntityApplicationRead[] {
    return this.application?.parcels?.filter(v => v?.tag === 'parcels') || [];
  }

  public get parcels2(): ParcelAppEntityApplicationRead[] {
    return this.application?.parcels?.filter(v => v?.tag === 'parcels2') || [];
  }
}
